var childrenMatcher = function (params, data) {
  var filteredChildren, modifiedData;

  if ($.trim(params.term) === '') {
    return data;
  }

  if (typeof data.children === 'undefined') {
    return null;
  }

  filteredChildren = [];
  $.each(data.children, function (idx, child) {
    if (child.text.toUpperCase().indexOf(params.term.toUpperCase()) > -1) {
      filteredChildren.push(child);
    }
  });

  if (filteredChildren.length) {
    modifiedData = $.extend({}, data, true);
    modifiedData.children = filteredChildren;
    return modifiedData;
  }

  return null;
};

module.exports = childrenMatcher;
